import { defineMessages } from 'react-intl';

type MessageKeys = 'answerNowButtonLabel' | 'answerNowButtonLoadingLabel';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		answerNowButtonLabel: {
			id: 'ai-mate.answer-now-button.label',
			defaultMessage: 'Answer now',
			description: 'Button label to skip extended thinking and get a faster response',
		},
		answerNowButtonLoadingLabel: {
			id: 'ai-mate.answer-now-button.loading-label',
			defaultMessage: 'Switching to fast mode...',
			description: 'Loading state label when switching to fast response mode',
		},
	});

export default message;
